import type { ShopUsdWalletLedgerResponse, ShopUsdWalletLedgerRow } from '../types';

const OWNER_ID = '3d91c648-4813-4d01-8cbb-a21509a7d573';
const WALLET_ID = '8643f089-14a5-4b42-b04a-8f2f994cbd06';

const usdWallet = {
  id: WALLET_ID,
  ownerType: 'shop',
  ownerId: OWNER_ID,
  currency: 'USD',
};

const shopParty = {
  ownerType: 'shop',
  ownerId: OWNER_ID,
  displayName: 'Kei Shop',
  roleLabel: 'Shop',
  label: 'Shop · Kei Shop',
};

function minutesAgo(minutes: number): string {
  return new Date(Date.now() - minutes * 60_000).toISOString();
}

/** Local-dev fixture mirroring production ledger shapes for Activity column QA. */
function buildStubRows(): ShopUsdWalletLedgerRow[] {
  const rows: ShopUsdWalletLedgerRow[] = [
    {
      id: '367ae3bd-0c97-4352-a607-fd5e3a580197',
      usdWalletId: WALLET_ID,
      transactionId: 'balance_to_credits:usd:2554a8cf-f8c9-4584-b746-f3ee2ff91e2a',
      type: 'purchase_credits',
      referenceType: 'balance_to_credits',
      referenceId: '2554a8cf-f8c9-4584-b746-f3ee2ff91e2a',
      amountGross: '0.78',
      amountNet: '0.78',
      balanceGrossBefore: '4.01',
      balanceGrossAfter: '3.23',
      balanceNetBefore: '0.78',
      balanceNetAfter: '0',
      metadata: { purpose: 'balance_to_credits', credits_out: 3.9 },
      status: 'completed',
      createdAt: minutesAgo(5),
      usdWallet,
      fromParty: shopParty,
      toParty: {
        ownerType: 'external',
        displayName: 'Internal transfer',
        roleLabel: 'Sent to',
        label: 'Sent to Internal transfer',
      },
      ledgerType: 'purchase_credits',
    },
    {
      id: '7b13524f-fdb6-4377-a31a-0bb3115290c0',
      usdWalletId: WALLET_ID,
      transactionId:
        'usd_withdrawal_request:shop:3d91c648-4813-4d01-8cbb-a21509a7d573:d84a5c87-3f1f-48a7-929b-81a72604a343',
      type: 'withdrawal',
      provider: 'btcpay',
      referenceType: 'usd_withdrawal_request',
      referenceId:
        'usd_withdrawal_request:shop:3d91c648-4813-4d01-8cbb-a21509a7d573:d84a5c87-3f1f-48a7-929b-81a72604a343',
      amountGross: '4.04',
      amountNet: '4.04',
      balanceGrossBefore: '8.05',
      balanceGrossAfter: '4.01',
      balanceNetBefore: '4.82',
      balanceNetAfter: '0.78',
      metadata: { createdBy: 'shop_portal', requestedNetUsd: 4, payoutNetwork: 'btc' },
      status: 'completed',
      createdAt: minutesAgo(20),
      usdWallet,
      fromParty: shopParty,
      toParty: {
        ownerType: 'external',
        displayName: 'Bitcoin',
        roleLabel: 'Sent to',
        label: 'Sent to Bitcoin',
      },
      ledgerType: 'withdraw',
      paymentMethod: 'BTCPAY',
    },
    {
      id: 'a53c3646-e2a0-4098-922e-63bc6a1e97ad',
      usdWalletId: WALLET_ID,
      transactionId:
        'usd_withdrawal:player_payout:WD_1782868157708_d60975af:shop:3d91c648-4813-4d01-8cbb-a21509a7d573',
      type: 'withdrawal',
      provider: 'zeroxprocessing',
      referenceType: 'payment_transaction',
      referenceId: '2642',
      amountGross: '15.73',
      amountNet: '15.73',
      balanceGrossBefore: '23.78',
      balanceGrossAfter: '8.05',
      balanceNetBefore: '20.55',
      balanceNetAfter: '4.82',
      metadata: {
        source: 'playerPayoutTierSettlementBizService',
        playerId: 'd60975af-e2d8-45be-b86e-eb421bf39550',
      },
      status: 'completed',
      createdAt: minutesAgo(35),
      usdWallet,
      fromParty: shopParty,
      toParty: {
        ownerType: 'external',
        displayName: 'Crypto (0xProcessing)',
        roleLabel: 'Sent to',
        label: 'Sent to Crypto (0xProcessing)',
      },
      ledgerType: 'withdraw',
      paymentMethod: 'USDT TRC20',
    },
    {
      id: '7d8b3d56-2032-4c71-8a45-2c27d83e0968',
      usdWalletId: WALLET_ID,
      transactionId:
        'usd_deposit:payment_tx:2641:shop:3d91c648-4813-4d01-8cbb-a21509a7d573:zerox_static_wallet',
      type: 'deposit',
      provider: 'zeroxprocessing',
      referenceType: 'payment_transaction',
      referenceId: '2641',
      amountGross: '8.49',
      amountNet: '8.32',
      balanceGrossBefore: '15.29',
      balanceGrossAfter: '23.78',
      balanceNetBefore: '12.23',
      balanceNetAfter: '20.55',
      metadata: { source: 'zerox_static_wallet_usd_only', staticWallet: true },
      status: 'completed',
      createdAt: minutesAgo(50),
      usdWallet,
      fromParty: {
        ownerType: 'external',
        displayName: 'Crypto (0xProcessing)',
        roleLabel: 'Received via',
        label: 'Received via Crypto (0xProcessing)',
      },
      toParty: shopParty,
      ledgerType: 'deposit',
      paymentMethod: 'Zeroxprocessing Static Wallet',
    },
    {
      id: '04ca8442-8efe-4135-9a3f-b372cbee940e',
      usdWalletId: WALLET_ID,
      transactionId:
        'usd_deposit:payment_tx:2640:payer:shop:3d91c648-4813-4d01-8cbb-a21509a7d573:player:d60975af-e2d8-45be-b86e-eb421bf39550',
      type: 'deposit',
      provider: 'zeroxprocessing',
      referenceType: 'payment_transaction',
      referenceId: '2640',
      amountGross: '13',
      amountNet: '10.14',
      balanceGrossBefore: '2.29',
      balanceGrossAfter: '15.29',
      balanceNetBefore: '2.09',
      balanceNetAfter: '12.23',
      metadata: {
        source: 'depositSettlementCoreService.creditPlayerMainWallet',
        playerId: 'd60975af-e2d8-45be-b86e-eb421bf39550',
      },
      status: 'completed',
      createdAt: minutesAgo(65),
      usdWallet,
      fromParty: {
        ownerType: 'external',
        displayName: 'Crypto (0xProcessing)',
        roleLabel: 'Received via',
        label: 'Received via Crypto (0xProcessing)',
      },
      toParty: shopParty,
      ledgerType: 'deposit',
      paymentMethod: 'USDT TRC20',
    },
    {
      id: '42845c4d-0943-4597-ba14-a1551873fc07',
      usdWalletId: WALLET_ID,
      transactionId:
        'usd_withdrawal_request:shop:3d91c648-4813-4d01-8cbb-a21509a7d573:54f8cbfd-3063-4b91-9172-cab22f18255e',
      type: 'withdrawal',
      provider: 'zeroxprocessing',
      referenceType: 'usd_withdrawal_request',
      referenceId:
        'usd_withdrawal_request:shop:3d91c648-4813-4d01-8cbb-a21509a7d573:54f8cbfd-3063-4b91-9172-cab22f18255e',
      amountGross: '2',
      amountNet: '2',
      balanceGrossBefore: '4.29',
      balanceGrossAfter: '2.29',
      balanceNetBefore: '4.09',
      balanceNetAfter: '2.09',
      metadata: { createdBy: 'shop_portal', payoutNetwork: 'eth' },
      status: 'completed',
      createdAt: minutesAgo(3 * 24 * 60),
      usdWallet,
      fromParty: shopParty,
      toParty: {
        ownerType: 'external',
        displayName: 'Crypto (0xProcessing)',
        roleLabel: 'Sent to',
        label: 'Sent to Crypto (0xProcessing)',
      },
      ledgerType: 'withdraw',
      paymentMethod: 'Zeroxprocessing',
    },
    {
      id: '5dbafa71-b937-4c91-8e6f-3abbb0e4be2a',
      usdWalletId: WALLET_ID,
      transactionId:
        'usd_withdrawal:player_payout:WD_1782404694013_d60975af:shop:3d91c648-4813-4d01-8cbb-a21509a7d573',
      type: 'withdrawal',
      provider: 'btcpay',
      referenceType: 'payment_transaction',
      referenceId: '2449',
      amountGross: '20.2',
      amountNet: '20.2',
      balanceGrossBefore: '24.49',
      balanceGrossAfter: '4.29',
      balanceNetBefore: '24.29',
      balanceNetAfter: '4.09',
      metadata: {
        source: 'playerPayoutTierSettlementBizService',
        playerId: 'd60975af-e2d8-45be-b86e-eb421bf39550',
      },
      status: 'completed',
      createdAt: minutesAgo(4 * 24 * 60),
      usdWallet,
      fromParty: shopParty,
      toParty: {
        ownerType: 'external',
        displayName: 'Bitcoin (BTCPay)',
        roleLabel: 'Sent to',
        label: 'Sent to Bitcoin (BTCPay)',
      },
      ledgerType: 'withdraw',
      paymentMethod: 'DOGE',
    },
    {
      id: '2235a409-f5c0-4082-a55b-2ff5a6e53d95',
      usdWalletId: WALLET_ID,
      transactionId:
        'usd_deposit:payment_tx:2448:shop:3d91c648-4813-4d01-8cbb-a21509a7d573:zerox_static_wallet',
      type: 'deposit',
      provider: 'zeroxprocessing',
      referenceType: 'payment_transaction',
      referenceId: '2448',
      amountGross: '4.49',
      amountNet: '4.49',
      balanceGrossBefore: '20',
      balanceGrossAfter: '24.49',
      balanceNetBefore: '19.8',
      balanceNetAfter: '24.29',
      metadata: { source: 'zerox_static_wallet_usd_only', staticWallet: true },
      status: 'completed',
      createdAt: minutesAgo(5 * 24 * 60),
      usdWallet,
      fromParty: {
        ownerType: 'external',
        displayName: 'Crypto (0xProcessing)',
        roleLabel: 'Received via',
        label: 'Received via Crypto (0xProcessing)',
      },
      toParty: shopParty,
      ledgerType: 'deposit',
      paymentMethod: 'Zeroxprocessing Static Wallet',
    },
    {
      id: '3ad7ec5a-850d-49a4-ac16-c4b1fbaf3eb4',
      usdWalletId: WALLET_ID,
      transactionId:
        'usd_deposit:payment_tx:2447:payer:shop:3d91c648-4813-4d01-8cbb-a21509a7d573:player:d60975af-e2d8-45be-b86e-eb421bf39550',
      type: 'deposit',
      provider: 'btcpay',
      referenceType: 'payment_transaction',
      referenceId: '2447',
      amountGross: '10',
      amountNet: '9.9',
      balanceGrossBefore: '10',
      balanceGrossAfter: '20',
      balanceNetBefore: '9.9',
      balanceNetAfter: '19.8',
      metadata: {
        source: 'depositSettlementCoreService.creditPlayerMainWallet',
        playerId: 'd60975af-e2d8-45be-b86e-eb421bf39550',
      },
      status: 'completed',
      createdAt: minutesAgo(6 * 24 * 60),
      usdWallet,
      fromParty: {
        ownerType: 'external',
        displayName: 'Bitcoin (BTCPay)',
        roleLabel: 'Received via',
        label: 'Received via Bitcoin (BTCPay)',
      },
      toParty: shopParty,
      ledgerType: 'deposit',
      paymentMethod: 'Doge Chain',
    },
    {
      id: 'c1a527df-0126-4ec1-9b1c-27a374e7fc29',
      usdWalletId: WALLET_ID,
      transactionId:
        'usd_deposit:payment_tx:2443:payer:shop:3d91c648-4813-4d01-8cbb-a21509a7d573:player:d60975af-e2d8-45be-b86e-eb421bf39550',
      type: 'deposit',
      provider: 'btcpay',
      referenceType: 'payment_transaction',
      referenceId: '2443',
      amountGross: '10',
      amountNet: '9.9',
      balanceGrossBefore: '0',
      balanceGrossAfter: '10',
      balanceNetBefore: '0',
      balanceNetAfter: '9.9',
      metadata: {
        source: 'depositSettlementCoreService.creditPlayerMainWallet',
        playerId: 'd60975af-e2d8-45be-b86e-eb421bf39550',
      },
      status: 'completed',
      createdAt: minutesAgo(7 * 24 * 60),
      usdWallet,
      fromParty: {
        ownerType: 'external',
        displayName: 'Bitcoin (BTCPay)',
        roleLabel: 'Received via',
        label: 'Received via Bitcoin (BTCPay)',
      },
      toParty: shopParty,
      ledgerType: 'deposit',
      paymentMethod: 'Doge Chain',
    },
  ];

  return rows;
}

let cachedRows: ShopUsdWalletLedgerRow[] | null = null;

function getRows(): ShopUsdWalletLedgerRow[] {
  if (!cachedRows) cachedRows = buildStubRows();
  return cachedRows;
}

export function getShopOnlineBalanceLedgerStub(): ShopUsdWalletLedgerResponse {
  const rows = getRows();
  return {
    ownerType: 'shop',
    ownerId: OWNER_ID,
    currency: 'USD',
    walletId: WALLET_ID,
    balanceGross: '3.23',
    balanceNet: '0',
    status: 'active',
    count: rows.length,
    rows,
  };
}

export function getShopOnlineBalanceLedgerStubRowById(
  id: string,
): ShopUsdWalletLedgerRow | undefined {
  return getRows().find((row) => row.id === id);
}

export const SHOP_ONLINE_BALANCE_LEDGER_STUB_ENABLED =
  process.env.REACT_APP_STUB_SHOP_ONLINE_BALANCE_LEDGER === 'true';
